var map = {
	"./15_happy.mp3": "0e6e",
	"./17_calm.mp3": "350b",
	"./18_angry.mp3": "88d2",
	"./20_hungry.mp3": "96ce",
	"./21_scared.mp3": "9807",
	"./M_Brilliant.mp3": "ca91",
	"./M_Excellent.mp3": "1bfe",
	"./M_Fantastic.mp3": "53c2",
	"./M_Great.mp3": "5253",
	"./M_Perfect.mp3": "f547",
	"./M_Think again.mp3": "e47e",
	"./M_Try again.mp3": "e634",
	"./M_Very good.mp3": "4a14",
	"./M_Well done.mp3": "8dbc",
	"./M_Work harder.mp3": "4b61",
	"./click.mp3": "8322",
	"./false.mp3": "0437"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "da30";